var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({width: `${_vm.width/10}rem`, height: `${_vm.height/10}rem`})})
}
var staticRenderFns = []

export { render, staticRenderFns }